import { Story } from '../../DocTypes';

export const dataFormattingStory: Story = {
  title: 'Data formatting',
  description: 'List with items with numbers and dates formatted',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    left-label-1='Value:'
    left-field-1='value'
    left-field-1-type='currency'
    right-label-1='Date of Birth:'
    right-field-1='dob'
    right-field-1-type='date'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Jordan Pickford', value: 35000000, dob: '1994-03-09T00:00:00.000Z' },
      { name: 'John Stones', value: 47500000, dob: '1994-03-09T00:00:00.000Z' },
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   primary-field='name'
  //   left-label-1='Value:'
  //   left-field-1='value'
  //   left-field-1-type='currency'
  //   right-label-1='Date of Birth:'
  //   right-field-1='dob'
  //   right-field-1-type='date'>
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');
  //   tagList.setData([
  //     { name: 'Jordan Pickford', value: 35000000, dob: '1994-03-09T00:00:00.000Z' },
  //     { name: 'John Stones', value: 47500000, dob: '1994-03-09T00:00:00.000Z' },
  //   ]);
  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    leftLabel1='Value:'
    leftField1='value'
    leftField1Type='currency'
    rightLabel1='Date of Birth:'
    rightField1='dob'
    rightField1Type='date'
    data={[
      { name: 'Jordan Pickford', value: 35000000, dob: '1994-03-09T00:00:00.000Z' },
      { name: 'John Stones', value: 47500000, dob: '1994-03-09T00:00:00.000Z' },
    ]}
  />`,
  },
};
